import { createI18n } from 'vue-i18n'
// 修改语言包导入路径，明确指定.js扩展名
import zh from './zh.js'
import en from './en.js'
// 添加日语语言包导入
import ja from './ja.js'

const messages = {
  zh,
  en,
  ja
}

// 自动获取浏览器语言
function getBrowserLanguage() {
  const language = navigator.language.toLowerCase()
  if (language.includes('zh')) {
    return 'zh'
  } else if (language.includes('ja') || language.includes('jp')) {
    return 'ja'
  }
  return 'en'
}

const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: localStorage.getItem('language') || getBrowserLanguage(), // 从localStorage获取或使用浏览器默认语言
  fallbackLocale: 'zh', // 回退语言
  messages
})


export default i18n;